import React from 'react';
import Icon from '../../../components/AppIcon';

const FooterSection = ({ onContactSupport }) => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = [
    {
      title: 'Product',
      links: [
        { label: 'Features', href: '#features' },
        { label: 'Pricing', href: '#pricing' },
        { label: 'Demo', href: '#demo' },
        { label: 'FAQ', href: '#faq' },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'Documentation', href: '#docs' },
        { label: 'Tutorials', href: '#tutorials' },
        { label: 'Blog', href: '#blog' },
        { label: 'Community', href: '#community' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', href: '#about' },
        { label: 'Careers', href: '#careers' },
        { label: 'Contact', href: '#contact' },
        { label: 'Privacy Policy', href: '#privacy' },
      ],
    },
  ];

  const socialLinks = [
    { icon: 'Twitter', label: 'Twitter', href: '#twitter' },
    { icon: 'Facebook', label: 'Facebook', href: '#facebook' },
    { icon: 'Linkedin', label: 'LinkedIn', href: '#linkedin' },
    { icon: 'Youtube', label: 'YouTube', href: '#youtube' },
  ];

  return (
    <footer className="bg-card border-t border-border py-8 md:py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10 mb-8 md:mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4 md:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center mr-3">
                <Icon name="BookOpen" size={24} className="text-primary" />
              </div>
              <span className="text-xl md:text-2xl font-semibold text-foreground">LearningTrails</span>
            </div>
            <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-6 max-w-md">
              Empowering educators to create interactive learning experiences with AI-powered tools and comprehensive analytics.
            </p>
            <button
              onClick={onContactSupport}
              className="flex items-center text-sm md:text-base text-primary hover:text-primary/80 transition-organic"
            >
              <Icon name="Mail" size={18} className="mr-2" />
              Contact Support
            </button>
          </div>

          {footerLinks?.map((section, index) => (
            <div key={index}>
              <h3 className="text-sm md:text-base font-semibold text-foreground mb-3 md:mb-4">
                {section?.title}
              </h3>
              <ul className="space-y-2 md:space-y-3">
                {section?.links?.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link?.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-organic"
                    >
                      {link?.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 md:pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
            <p className="text-xs md:text-sm text-muted-foreground text-center md:text-left">
              &copy; {currentYear} LearningTrails. All rights reserved.
            </p>

            <div className="flex items-center space-x-4 md:space-x-6">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.href}
                  aria-label={social?.label}
                  className="w-8 h-8 md:w-10 md:h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-primary/10 transition-organic active-press"
                >
                  <Icon name={social?.icon} size={18} className="text-muted-foreground hover:text-primary" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;